<template>
<!-- 과정항목 관리 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn">
                    </span>
                </a>
                <div class="modal-body">
                    <div>
                        <h3 class="font-14 bold mb-10">과정항목 관리</h3>
                        <ag-grid-vue style="height: 320px; width:100%; font-size: 12px" @row-drag-enter="onRowDragEnter" @row-drag-end="onRowDragEnd" @row-drag-move="onRowDragMove" @row-drag-leave="onRowDragLeave" :rowDragManaged="true" :animateRows="true" class="ag-theme-balham" :columnDefs="columnDefs" :rowData="itemList" :gridOptions="gridOptions" @grid-ready="onGridReady" :frameworkComponents="frameworkComponents" :context="context" :defaultColDef="defaultColDef">
                        </ag-grid-vue>
                        <span class="font-10" style="font-size: 13px !important;display: inline-block;    margin-top: 10px;line-height: 19px !important;">
                            * 상세 및 기타 : 추가정보나 커리큘럼 설명 등 긴 글을 작성 시 [내용]을 눌러 입력해주세요. (학습자 화면에는 바로 노출되지 않으며 클릭해야 상세 정보 Display 됩니다.)
                        </span>
                    </div>
                    <div class="mt-10" v-if="!(limit_way == 'N') && !(limit_way == 'P')">
                        <h3 class="font-14 bold">신청자 수</h3>
                        <label for="apply" >
                            <input type="radio" v-model="applyType" value="N" name="applyType" id="">
                            <span class="txt-13px ml-05 mr-20">제한 없음</span>
                        </label>
                        <label for="apply" >
                            <input type="radio" v-model="applyType" value="AF" name="applyType" id="">
                            <span class="txt-13px ml-05 mr-20">클래스 전체 선착순</span>
                        </label>
                        <label for="apply">
                            <input type="radio" v-model="applyType" value="SF" name="applyType" id="">
                            <span class="txt-13px ml-05 mr-20">클래스 별 선착순</span>
                        </label>
                    </div>
                    <div v-if="applyType === 'AF'" class="mt-10">
                        <div>
                            <label for="order">
                                <span class="txt-13px ml-05 mr-20">선착순</span>
                                <input type="text" class="w-40px" v-model="faNum" @keyup="onlyNumber('faNum')" @change="onlyNumber('faNum')" name="button" id="">
                                <span class="txt-13px ml-05 mr-20">명</span>
                            </label>
                            <label for="order">
                                <input type="checkbox" v-model="restYn" true-value="Y" false-value="N" name="button" id="">
                                <span class="txt-13px ml-05 mr-20">잔여인원 표시</span>
                            </label>
                        </div>
                        <div>
                            <label for="wait">
                                <input type="radio" v-model="addWaits" :value="true" name="addWaits" id="">
                                <span class="txt-13px ml-05 mr-20">대기자 받음</span>
                                <input type="text" class="w-40px" v-model="waitingNum" @keyup="onlyNumber('waitingNum')" @change="onlyNumber('waitingNum')" name="button" id="">
                                <span class="txt-13px ml-05 mr-20">명</span>
                            </label>
                            <label for="wait">
                                <input type="radio" v-model="addWaits" :value="false" name="addWaits" id="">
                                <span class="txt-13px ml-05 mr-20">대기자 없음</span>
                            </label>
                        </div>
                    </div>
                    <div v-if="applyType === 'SF'" class="mt-10">
                        <label for="wait">
                            <input type="radio" v-model="addWaits" :value="true" name="addPartWaits" id="">
                            <span class="txt-13px ml-05 mr-20">대기자 받음</span>
                        </label>
                        <label for="wait">
                            <input type="radio" v-model="addWaits" :value="false" name="addPartWaits" id="">
                            <span class="txt-13px ml-05 mr-20">대기자 없음</span>
                            <input type="checkbox" v-model="restYn" true-value="Y" false-value="N" name="button" id="">
                            <span class="txt-13px ml-05 mr-20">잔여인원 표시</span>
                        </label>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="admin-btn-default btn pointer" data-dismiss="modal" aria-label="Close" @click="save()">저장</a>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import {
    AgGridVue
} from 'ag-grid-vue'
import {
    AllCommunityModules
} from '@ag-grid-community/all-modules'
import { ItemCheckComponent } from '@/utils/reg.enroll.grid.js'
export default {
    // gridIndex: 현재 몇번째 그리드를 수정하는지 index
    // parentCol: 항목을 등록한 적이 있는 경우 재 호출시 로딩한 데이터
    props: ['gridIndex', 'parentCol', 'parentApplys'],
    components: {
        AgGridVue
    },
    data: () => ({
        itemList: [{ // 항목 컬럼 데이터
                checked: true,
                item: '언어',
                field: 'language'
            },
            {
                checked: true,
                item: '과정명',
                field: 'subjectName'
            },
            {
                checked: true,
                item: '레벨',
                field: 'level'
            },
            {
                checked: true,
                item: '요일',
                field: 'day'
            },
            {
                checked: true,
                item: '교육시간',
                field: 'classTime'
            },
            {
                checked: true,
                item: '장소',
                field: 'place'
            },
            {
                checked: true,
                item: '강사',
                field: 'teacher'
            },
            {
                checked: true,
                item: '교육비',
                field: 'eduPrice'
            },
            {
                checked: true,
                item: '교재비',
                field: 'bookPrice'
            },
            {
              checked: true,
              item: '교재',
              field: 'book'
            },
            {
                checked: true,
                item: '상세 및 기타',
                field: 'etc'
            }
        ],
        applyType: 'N', // 신청자 수 타입 (N: 제한없음, AF: 전체 선착순, SF: 과정 선착순)
        faNum: '', // 선착순 설정 인원수
        restYn: 'N', // 잔여인원 표시 여부 (전체 선착순)
        addWaits: true, // 대기자 받음 여부 (전체 선착순)
        waitingNum: '', // 대기자 설정 인원수 (전체 선착순)
        addPartWaits: true, // 대기자 받음 여부 (과정 별 선착순)
        addPartRemains: false, // 잔여인원 표시 여부 (과정 별 선착순)
        isReLoad: false, // 항목 데이터가 이미 있는데 재 호출했는지 여부

        /** ag-grid 옵션 변수들 선언 */
        gridOptions: null, // 그리드에 적용할 각 옵션 (열, 행, 헤더, 편집옵션 등)
        gridApi: null, // 그리드에 적용할 각 api ( 사이즈, get, set, 노드접근, 선택, 정렬 등)
        columnApi: null, // 컬럼에 사용할 각 api ( 행의 사이즈, get, set)
        columnDefs: null, // 컬럼에 들어갈 값 (헤더 데이터)
        rowData: null, // 열에 들어갈 값 (기본 데이터)
        defaultColDef: null, // 기본 컬럼 셋팅 (따로 컬럼에 옵션을 지정하지 않은 경우)
        modules: AllCommunityModules, // Ag-grid 모듈 사용 변수

        limit_way:''
    }),
    beforeMount() {
        console.log('모달 열림')
        console.log('gridIndex', this.gridIndex)
        console.log('this.parentApplys', this.parentApplys)

        this.columnDefs = [{
            headerName: '항목',
            rowDrag: true,
            cellRenderer: 'ItemCheckComponent',
            width: 414
        }];

        // 그리드에 적용가능한 여러가지 옵션 사항을 설정합니다.
        this.gridOptions = {
            headerHeight: 36,
            enableColResize: true
        }

        // 그리드에 적용할 컴포넌트 설정 (utils/reg.userInfo.grid.js 파일에 컴포넌트 지정)
        this.frameworkComponents = {
            ItemCheckComponent: 'ItemCheckComponent'
        }

        // 그리드에 삽입된 외부 컴포넌트에서 현재 컴포넌트 데이터에 접근하기 위함
        this.context = {
            componentParent: this
        }

        // 기본 컬럼 세팅 정의
        this.defaultColDef = {
            resizable: true // 컬럼 Width 조정가능
        }

        // 이미 항목 데이터가 있는 경우 현재 데이터 로딩
        if (this.parentCol !== '') {
            console.log('this.parentCol', this.parentCol)
            for (var item of this.itemList) {
                for (var col of this.parentCol) {
                    item.checked = false
                    if (col.item === item.item) {
                        console.log('거 잇니', item.item)
                        item.checked = true
                        break
                    }
                }
            }

            console.log('this.itemList', this.itemList)
            // this.itemList = JSON.parse(JSON.stringify(this.parentCol))
            this.isReLoad = true
        }
    },

    mounted() {
        this.limit_way = sessionStorage.getItem("limit_way")
        console.log(this.limit_way);
        if (this.parentApplys !== '') {
            this.applyType = this.parentApplys.applyType
            if (this.applyType === 'AF') {
                this.faNum = this.parentApplys.faNum
                this.restYn = this.parentApplys.restYn
                this.addWaits = this.parentApplys.addWaits
                this.waitingNum = this.parentApplys.waitingNum
            } else if (this.applyType === 'SF') {
                this.restYn = this.parentApplys.restYn
                this.addWaits = this.parentApplys.addWaits
            }
        }
    },

    beforeDestroy() {
        console.log('메모리 해제')
    },

    watch: {
        addWaits() {
            if (!this.addWaits) {
                this.waitingNum = ''
            }
        }
    },

    methods: {
        // 행 드래그 종료시 이벤트 함수
        onRowDragEnd(e) {
            this.gridApi.refreshClientSideRowModel()
            var tempData = []
            this.gridApi.forEachNode(function (rowNode, index) {
                tempData.push(rowNode.data)
                console.log('index', index)
                console.log('rowNode.data', rowNode.data);
            });

            this.itemList = JSON.parse(JSON.stringify(tempData))
            console.log('onRowDragEnd', e);
        },

        // 그리드 랜더링 완료된 경우 호출
        onGridReady() {
            this.gridApi = this.gridOptions.api
            this.gridColumnApi = this.gridOptions.columnApi
        },

        gridSizeFit(params) {
            // 모니터나 브라우저 크기에 따라 반응하여 그리드 컬럼 사이즈를 조정합니다.
            if (window.innerWidth > 800) {
                params.api.sizeColumnsToFit() // 가로 스크롤바가 생기지 않도록 컬럼 사이즈를 그리드에 꼭 맞게 조정합니다.
            } else {
                // 컬럼의 데이터값이 잘리지 않도록 조정합니다.
                let allColumnIds = []
                this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId)
                })
                this.gridOptions.columnApi.autoSizeColumns(allColumnIds)
            }
        },

        // 한글, 영어, 특수문자 막기
        onlyNumber(variable) {
            this[variable] = this[variable].replace(/[^0-9]/g, '')
        },

        // 항목 데이터 등록 페이지(enroll.vue) 그리드에 전달
        save() {
            // 과정 전체 선착순일때 validation
            var mappingData = {}
            mappingData['applyType'] = this.applyType
            mappingData['index'] = this.gridIndex

            // 재 로딩인지 여부
            if (this.isReLoad) {
                mappingData['isReLoad'] = true
            }

            // 각 신청자 수 타입별로 데이터 부모 페이지에 전달
            if (this.applyType === 'AF') {
                console.log('this.faNum', this.faNum)
                console.log('this.faNum', typeof this.faNum)
                if (typeof this.faNum !== 'number' && this.faNum.trim() === '') {
                    alert('선착순 인원수를 입력해주세요.')
                    return false
                }
                if (this.addWaits) {
                    if (typeof this.waitingNum !== 'number' && this.waitingNum.trim() === '') {
                        alert('대기자 인원수를 입력해주세요.')
                        return false
                    }
                }

                mappingData['faNum'] = this.faNum
                mappingData['restYn'] = this.restYn
                mappingData['addWaits'] = this.addWaits
                mappingData['waitingNum'] = this.waitingNum
            } else if (this.applyType === 'SF') {
                mappingData['restYn'] = this.restYn
                mappingData['addWaits'] = this.addWaits
            }

            var itemList = []
            for (var item of this.itemList) {
                if (item.checked === true) {
                    itemList.push(item)
                }
            }

            this.$emit('save', itemList, mappingData)
        }
    }
}
</script>

<style scoped>
/* 화살표 세개 표시는 ag-grid 특성상 일반 클래스가 먹히지 않으므로 적용해야 됨 */
div>>>.ag-theme-balham .ag-ltr .ag-cell {
    justify-content: left;
}
</style><style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.1s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.1s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
